export default __webpack_public_path__ + "static/media/1405.91ca0b5b.png";